<template>
	<div
		class="payment-request-export-status"
		:class="paymentRequest.exportState.modifier"
	>
		<div class="title">
			<VIcon :material="paymentRequest.exportState.icon" />
			<span>{{ paymentRequest.exportState.label }}</span>
		</div>
		<div v-if="paymentRequest.isManual" class="description">
			Ручной платёж
		</div>
	</div>
</template>

<script lang="ts">
import type PaymentRequest from '@/domains/PaymentRequests/PaymentRequest';

export default defineComponent({
	name: 'PaymentRequestExportStatus',

	props: {
		paymentRequest: {
			type: Object as PropType<PaymentRequest>,
			required: true,
		},
	},
});
</script>

<style lang="scss" scoped>
.payment-request-export-status {
	.title {
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.mds-icon {
			flex: 0 0 auto;
			margin-right: 5px;
			font-size: 14px;
		}

		span {
			display: block;
			flex: 1 1 auto;
			max-width: 100px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}
}
</style>